module.exports = "<div class=\"spinner-container\" *ngIf=\"showSpinner\">\n  <div class=\"spinner\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/spinner/spinner.component.html
// module id = ../../../../../src/app/shared/components/spinner/spinner.component.html
// module chunks = main